import GameSettingsItem from './GameSettingsItem'
import { useGameSettingsItems } from './useGameSettingsItems'

const GameSettings = () => {
    const renderItems = () => {
        const items = useGameSettingsItems()

        return items.map((props) => <GameSettingsItem key={props.label} {...props} />)
    }

    return (
        <div className="flex flex-col text-white w-full justify-center items-center touch-auto [&_div]:touch-auto">
            <div className="w-[680px]">{renderItems()}</div>
        </div>
    )
}

export default GameSettings
